module.exports = "/_next/static/images/harajuku_station_near-655be608fe2462a1ad91cf483710e45d.jpg";